import React, { Fragment } from 'react'
import PagesHeading from '../pages-heding/PagesHeading'
import StudentWelfareServices from '../student-welfare-services/StudentWelfareServices'

const StudentWelfareServicesPage = (props) => {
  return (
    <Fragment>
        <PagesHeading page_title={props.page_title}></PagesHeading>
        <StudentWelfareServices></StudentWelfareServices>
    </Fragment>
  )
}

export default StudentWelfareServicesPage